import { set } from 'firebase/database';
import _ from 'lodash';
import { PiniaPluginContext } from 'pinia';
import { RunMode } from '~~/interface/Pos';
import {  updateDoc, setDoc } from "firebase/firestore";
import { FIRESTORE_COLLECTIONS } from "~~/interface/FirestoreCollections";
import { reportLiveSyncError, trackSyncWrite } from "~~/modules/core/utils/liveSyncStatus";
import { buildTableMeta } from "../composables/useTableSync";

function TableMetaPlugin({ store }: PiniaPluginContext) {
  if (store.$id == "jobs") {
    const firestoreDb = useFirebaseFirestore();
    let previousTableState = null;
    let firstLoad = true;
    let syncToFirebaseLazy = _.debounce(syncToFirebase, 1500);

    // เช็คโหมดตอน sync ไม่ใช่ตอนสร้าง store — เหตุผลเดียวกับ mobile.items.plugin.ts
    store.$subscribe((mutation, state) => {
      if (previousTableState != state.tables) {
        previousTableState = state.tables;
        syncToFirebaseLazy();
      }
    });


    function syncToFirebase() {
      if (firstLoad) {
        firstLoad = false;
        return;
      }

      if (useRunningMode().getMode() !== RunMode.MAIN_CASHIER) return;

      let _res = {}
      try {
        _res = buildTableMeta(store as any);
      } catch (error) {
        reportLiveSyncError("tableMetaCompute", error);
        return;
      }

      //sync tableMeta
      trackSyncWrite("tableMeta", () => set(useFirebase().tableMetaRef(), _res));

      //SYNC TO FIRESTORE
      trackSyncWrite("tableMetaFirestore", () => updateTableMetaToFirestore(_res));
    }

    function updateTableMetaToFirestore(tableMetaData){
      let tableMetaRef = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.SYNC_DATA,FIRESTORE_COLLECTIONS.TABLE_META)
      return setDoc(tableMetaRef, tableMetaData);
    }

  }
}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(TableMetaPlugin);
});
